<template>
  <v-content
  >
    <mobile-cards
      v-if="isDesignByCards && subDomain && isMobile && !isForceList"
      :domain="subDomain"
      :locale="locale"
    />
    <mobile
      v-else-if="subDomain && isMobile"
      :domain="subDomain"
    />
    <desktop-cards
      v-else-if="designByCardsDesktop && subDomain && !isMobile"
      :domain="subDomain"
      :locale="locale"
    />
    <desktop
      v-else-if="subDomain && !isMobile"
      :domain="subDomain"
    />
    <custom-modal v-if="!touchPublic" />
    <hotelequia  v-if="!touchPublic" />
    <div v-if="!touchPublic" >
    <floating-dial-custom v-if="customDial" :dial="customDial" :locale="locale" :color="dialColor"/>
    <floating-dial v-else-if="dial" :dial="dial" :locale="locale" :color="dialColor"/>
    <whats-app v-else />
    <CMMessages
      v-if="isMessages"
      :locale="locale"
      color="#123123"
      :workspaceID="workspaceID"
    />
    </div>
    <cookie-policy
      v-if="workspaceID"
      :workspaceID="workspaceID"
      :locale="locale"
    />
    <order-result
      :orderID="orderID"
      :orderStatus="orderStatus"
      :locale="locale"
    />
  </v-content>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import api from '@/services/api'
  import Mobile from './mobile/Index'
  import MobileCards from './mobile/mobileCards/Index'
  import Desktop from './desktop/Index'
  import DesktopCards from './desktop/desktopCards/Index'
  import utils from '@/services/utils.js'
  import CustomModal from '@/components/customModal/Index'
  import Hotelequia from './Hotelequia'
  import FloatingDial from './FloatingDial'
  import FloatingDialCustom from './FloatingDialCustom'
  import WhatsApp from './WhatsApp'
  import CMMessages from './cMMessages/Index'
  import CookiePolicy from './cookiePolicy/Index'
  import OrderResult from './OrderResult'
  export default {
    components: {
      Mobile,
      Desktop,
      CustomModal,
      Hotelequia,
      FloatingDial,
      FloatingDialCustom,
      WhatsApp,
      MobileCards,
      DesktopCards,
      CMMessages,
  CookiePolicy,
      OrderResult,
    },
    data: () => ({
      dial: null,
      dialColor: null,
      customDial: null,
      isDesignByCards: false,
      designByCardsDesktop: false,
      isMessages: false,
      workspaceID: null,
    }),
    computed: {
      ...mapState('app',['locale']),
      orderID () {
        return this.$route.params.orderID
      },
      orderStatus () {
        return this.$route.params.status
      },
      checkoutID () {
        // resume checkout back url
        return this.$route.params.checkoutID
      },
      pointID () {
        // resume checkout back url
        return this.$route.params.pointID
      },
      subDomain () {
        return utils.getDomain()
      },
      isForceMobile () {
        return this.$route.query.fm === 'true'
      },
      isForceList () {
        return this.$route.query.fl === 'true'
      },
      touchPublic () {
        return this.$route.query.touchPublic === 'true'
      },
      isMobile () {
        return utils.isMobile() || this.$route.query.fm === 'true' || this.$route.query.onlyContent
      },
      isIpad () {
        return utils.isIpad()
      },
      statsSRC () {
        return this.$route.query.src
      }
    },
    mounted() {
      this.prepareStatsSRC()
      utils.checkRedirect()
//      if (this.checkoutID) alert(this.checkoutID + '----' + this.pointID)
      this.$store.state.app.dtouchIsTouchPublic = this.touchPublic
      this.getEnterprise()
      this.test()
    },
    methods: {
      prepareStatsSRC () {
        //console.log(this.statsSRC, this.subDomain)
        if (this.statsSRC && this.statsSRC.indexOf(this.subDomain.concat('_')) >= 0) {
          const aux = this.statsSRC.split('_').pop()
          localStorage.setItem('statsSRC', aux)
        } else {
          localStorage.setItem('statsSRC', '')
        }
      },
      test() {
        const location = window.location
        //if ((location.host.indexOf('.lopesan.') > 0 || location.host.indexOf('.dtouch.local') > 0)) {
        if (utils.isLopesanDomain()) {
          if (location.href.indexOf('/#/') === -1) {
            const aux = `${location.origin}${location.pathname}${location.hash}${location.search}`
            window.location.href = aux
          }
          const idReservationLopesan = this.$route.query.i
          if (idReservationLopesan) {
            //const url =`https://360forhotels.lopesan.com/app.php/es/extrest/datos/minimos/reserva.json?idReserva=${idReservationLopesan}`
            const url = `https://www.dtouch.es/assets/lopesan.php?i=${idReservationLopesan}`
            axios.get(url)
              .then(response => {
                const {estado} = response.data.data
                if (estado && estado.id_estado === '4') {
                  this.$store.state.app.authData = {
                    id: idReservationLopesan,
                    name: ''
                  }
                } else {
                  this.$store.state.app.authData = null
                }
              })
              .catch( (error) => {
                console.log('error', error)
                this.$store.state.app.authData = null
              })
          } else {
            this.$store.state.app.authData = null
          }
        }
      },
      createAppleTouch (url) {
        const link = document.createElement('link')
        link.sizes = '120x120'
        link.rel = 'apple-touch-icon'
        link.href = url
        document.head.appendChild(link)

        const items = [
          {
            rel: 'shortcut icon',
            sizes: '128x128'
          },
          {
            rel: 'shortcut icon',
            sizes: '196x196'
          },
          {
            rel: 'apple-touch-icon-precomposed',
          }
        ]

        for (const item of items) {
          const linkAndroid = document.createElement('link')
          linkAndroid.rel = item.rel
          if (item.sizes) linkAndroid.sizes = item.sizes
          linkAndroid.href = url
          document.head.appendChild(linkAndroid)
        }

        //<link rel="apple-touch-icon" href="https://www.dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/icon120.png" sizes="120x120">
      },
      getEnterprise () {
        const auxID = this.ID ? this.ID : this.subDomain
        if (!auxID) {
          this.$router.push('/404')
          return
        }
          const aux = this.$route.query.c ? `?public=true&c=${this.$route.query.c}` : !this.isSimulation ? '?public=true' : ''
          api.getItem('enterprises', false, auxID.concat(aux)).then(response => {
            this.workspaceID = response.ID
            this.$store.state.app.webappWorkspaceID = response.ID

            this.isDesignByCards = response.DesignByCards || this.$route.query.onlyContent ? true : false
            this.designByCardsDesktop = response.DesignByCards && response.DesignByCardsDesktop

            if (this.isDesignByCards && this.isMobile && response.DesignByCardsLogo && response.DesignByCardsLogo.length > 0) {
              response.Logo = response.DesignByCardsLogo
            }

            this.isMessages = response.IsMessages

            if (this.isMobile && response.AppleIcon) this.createAppleTouch(response.AppleIcon)

            this.$store.state.app.isMenuLeft = response.IsMenuLeft
            if (response.FloatingDial) {
              this.dialColor = response.DialColor ? response.DialColor : response.BGColor ? response.BGColor : '#56A099'
              this.dial = []
              if(response.Dial1) {
                const aux = JSON.parse(response.Dial1)
                if (aux.URL && aux.URL.length > 0) {
                  aux.id = 'dial1'
                  this.dial.push(aux)
                }
              }
              this.$store.state.app.cacheFormData = response.CacheFormData && response.CacheFormData === 1 ? true : false

              if (response.InstagramURL && response.InstagramURL.length > 0) this.dial.push({id: 'instagram', color: '#D6249F', icon: 'mdi-instagram', URL: response.InstagramURL})
              if (response.YoutubeURL && response.YoutubeURL.length > 0) this.dial.push({id: 'youtube', color: '#c4302b', icon: 'mdi-youtube', URL: response.YoutubeURL})
              if (response.FacebookURL && response.FacebookURL.length > 0) this.dial.push({id: 'facebook', color: '#3b5998', icon: 'mdi-facebook', URL: response.FacebookURL})
              if (response.TwitterURL && response.TwitterURL.length > 0) this.dial.push({id: 'twitter', color:'#00acee', icon: 'mdi-twitter', URL: response.TwitterURL})
              if (response.WhatsApp && response.WhatsAppPhone && response.WhatsAppPhone.length > 0) this.dial.push({id: 'whatsapp', color: '#25D366', icon: 'mdi-whatsapp', URL: response.WhatsAppPhone})
            }
            this.customDial = response.FloatingDialCustom && response.FloatingDialCustom ? JSON.parse(response.FloatingDialCustom) : null

            if (!response.ID) {
              // TODO pendiente hacer la validación
              // si es privat
              this.$router.push('/404')
              // window.location.href = '/#/404'
            }


            if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone
            this.$store.state.app.allergenFilters = response.AllergenFilters
            this.$store.state.app.showDishesImage = response.ShowDishesImage
            this.$store.state.app.showDishesAllergens = response.ShowDishesAllergens
            this.$store.state.app.foodIconRight = response.FoodIconRight
            // if (!this.isSimulation) document.title = response.Name // se añade esto para que en el title aparezca el nombre del cliente
            this.$store.state.app.enterpriseName = response.Name
            this.$store.state.app.BGColor = response.BGColor ? response.BGColor : '#56A099'
            this.$store.state.app.btnBackgroundColor = response.BtnBackgroundColor ? response.BtnBackgroundColor : ''
            this.$store.state.app.btnTextColor = response.BtnTextColor ? response.BtnTextColor : ''
            this.$store.state.app.foodDrinkTextColor = response.FoodDrinkTextColor ? response.FoodDrinkTextColor : ''
            this.$store.state.app.foodDrinkBGColor = response.FoodDrinkBGColor ? response.FoodDrinkBGColor : ''

            this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
            this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
            this.$store.state.app.Color = response.Color ? response.Color : '#495057'
            this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
            this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
            this.logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png';
            this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'


            this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
            this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
            this.$store.state.app.withGradientSubmenu = response.GradientSubmenu === 1 ? true : false
            this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

            this.$store.state.app.GlobalFont = response.GlobalFont
            if (response.Font) this.$store.state.app.Font = response.Font
            if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
            if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

            if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
            if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
            if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent

            if (response.TextFormat) this.$store.state.app.TextFormat = response.TextFormat
            if (response.TextFormatSecundary) this.$store.state.app.TextFormatSecundary = response.TextFormatSecundary

            this.$store.state.app.Languages = response.Languages ? response.Languages.split(',') : ['es']

            const aux =response.DefaultLocale
            const navLocale = window.navigator && window.navigator.language && window.navigator.language.indexOf('-') > 0 ? window.navigator.language.split('-')[0].toLowerCase() : null

            // INI preparamos el idioma por defecto
            if (this.$route.query.locale && this.$route.query.locale.length > 0) {
              this.$store.state.app.locale =  this.$route.query.locale
            } else if (localStorage.getItem('locale') && localStorage.getItem('locale').length > 0){
              this.$store.state.app.locale = localStorage.getItem('locale')
            } else if (navLocale && this.$store.state.app.Languages.filter(x => x === navLocale).length > 0) {
              this.$store.state.app.locale = navLocale
            } else if (aux){
              this.$store.state.app.locale = aux
            } else {
              this.$store.state.app.locale = 'es'
            }
            // END preparamos el idioma por defecto

            this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
            this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'
          })

      },
    }
  }
</script>
